import * as React from "react";
import { Grid } from "semantic-ui-react";

interface Props {
    label: string;
    value: string;
}

const EmployeeDetail: React.FunctionComponent<Props> = (props) => {
    return (
        <Grid.Row>
            <Grid.Column className="primary-column" computer={6} mobile={16}><strong>{props.label}</strong></Grid.Column>
            <Grid.Column width="8">{props.value}</Grid.Column>
        </Grid.Row>
    );
};

export { EmployeeDetail };
